import getApi from '../../api/apisauceConfig'
import { ApiErrorContent } from '../../model/Error'

export interface SyncPatientInteropResponse {
  message: string
}

export const syncPatientInterop = (serial: string) =>
  // Corps JSON vide volontaire : la route n'attend aucun payload, mais sans
  // `Content-Type: application/json` le back ne convertit pas ses exceptions en
  // JSON (ExceptionToJsonSubscriber) et un 422 ressortirait en page 500 HTML.
  getApi().post<SyncPatientInteropResponse, ApiErrorContent>(`/interop/patients/${serial}/sync`, {})
